import axiosInstance from "@/services/http/axios-instance";

export class PaymentTypeApi {
  getPaymentTypes() {
    return axiosInstance.get("/payment-types");
  }

  getPaymentTypeFields(paymentTypeId) {
    return axiosInstance.get("/payment-types/fields", {
      params: {
        payment_type_id: paymentTypeId,
      },
    });
  }

  loadRequisitesByRegion(paymentTypeRegionId, paymentTypeId) {
    return axiosInstance.get("/payment-types/region/requisites", {
      params: {
        payment_type_region_id: paymentTypeRegionId,
        payment_type_id: paymentTypeId,
      },
    });
  }

  loadTermsByOption(paymentTypeOptionId) {
    return axiosInstance.get("/payment-types/option/terms", {
      params: {
        payment_type_option_id: paymentTypeOptionId,
      },
    });
  }

  loadRequisitesTemplates() {
    return axiosInstance.get("/payment-types/requisites/templates");
  }
}
